
  // Export
  module.exports =
  {

    voiceLabels:
    {

      // Method-wide scripts
      _init: function ()
      {

        $('#labels-yes').click(function ()
        {

          $('#voice_labels').val(1)

          $('#voice_contract_id').val($('#modal-voice_contract_id').val())

          $('#voice-form').submit()

        }
        )

        $('#labels-no').click(function ()
        {

          $('#voice_labels').val(0)

          $('#voice_contract_id').val($('#modal-voice_contract_id').val())

          $('#voice-form').submit()

        }
        )

      }

    }

  }